import {
  FETCH_INVOICES_RESOLVED,
  FETCH_INVOICE_RESOLVED,
  ISSUE_INVOICE_RESOLVED,
  LINK_INVOICE_ORDER_RESOLVED,
  ADD_INVOICE_EXTRA_FEE_RESOLVED,
  FETCH_CUSTOMER_AVAILABLE_BALANCE_RESOLVED,
  FETCH_ELIGIBLE_ORDERS_RESOLVED,
  ATTACH_INVOICE_TO_ORDER_RESOLVED,
  FETCH_ORDER_LINKED_INVOICES_RESOLVED,
} from "../ActionTypes/invoice";

const initialState = {
  invoices: [],
  invoice: {},
  customerAvailableBalance: {},
  eligibleOrders: [],
  orderLinkedInvoices: [],
};

const invoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INVOICES_RESOLVED:
      return Object.assign({}, state, {
        invoices: action.payload,
      });
    case FETCH_INVOICE_RESOLVED:
      return Object.assign({}, state, {
        invoice: action.payload,
      });
    case ISSUE_INVOICE_RESOLVED:
      return Object.assign({}, state, {
        invoice: action.payload,
      });
    case LINK_INVOICE_ORDER_RESOLVED:
      return Object.assign({}, state, {
        invoice: action.payload,
      });
    case ATTACH_INVOICE_TO_ORDER_RESOLVED:
      return Object.assign({}, state, {
        invoice: action.payload,
      });
    case ADD_INVOICE_EXTRA_FEE_RESOLVED:
      return Object.assign({}, state, {
        invoice: action.payload,
      });
    case FETCH_CUSTOMER_AVAILABLE_BALANCE_RESOLVED:
      return Object.assign({}, state, {
        customerAvailableBalance: action.payload,
      });
    case FETCH_ELIGIBLE_ORDERS_RESOLVED:
      return Object.assign({}, state, {
        eligibleOrders: action.payload,
      });
    case FETCH_ORDER_LINKED_INVOICES_RESOLVED:
      return Object.assign({}, state, {
        orderLinkedInvoices: action.payload,
      });
    default:
      return state;
  }
};

export default invoiceReducer;
